// Centralized Stripe configuration using environment variables
// This ensures we can use different price IDs for test vs production environments

export interface StripePriceConfig {
  single: string;
  team: string;
  enterprise: string;
}

// Environment variable fallbacks - these should only be used as last resort
// In production, always ensure environment variables are properly set
const FALLBACK_PRICE_IDS = {
  single: (typeof process !== 'undefined' && process.env?.STRIPE_SINGLE_PRICE_ID) || 'price_missing_single',
  team: (typeof process !== 'undefined' && process.env?.STRIPE_TEAM_PRICE_ID) || 'price_missing_team', 
  enterprise: (typeof process !== 'undefined' && process.env?.STRIPE_ENTERPRISE_PRICE_ID) || 'price_missing_enterprise'
};

export function getStripePriceIds(): StripePriceConfig {
  // Check if we're in a server environment
  if (typeof process === 'undefined') {
    // Client-side fallback - return fallback values
    return FALLBACK_PRICE_IDS;
  }
  
  return {
    single: process.env.STRIPE_SINGLE_PRICE_ID || FALLBACK_PRICE_IDS.single,
    team: process.env.STRIPE_TEAM_PRICE_ID || FALLBACK_PRICE_IDS.team,
    enterprise: process.env.STRIPE_ENTERPRISE_PRICE_ID || FALLBACK_PRICE_IDS.enterprise
  };
}

export function getPlanNameByPriceId(priceId: string): string {
  const priceIds = getStripePriceIds();
  
  if (priceId === priceIds.single) return 'single';
  if (priceId === priceIds.team) return 'team';
  if (priceId === priceIds.enterprise) return 'enterprise';
  
  return 'single'; // fallback
}

export function getPlanIdByPriceId(priceId: string): number {
  const priceIds = getStripePriceIds();
  
  if (priceId === priceIds.single) return 2;
  if (priceId === priceIds.team) return 3;
  if (priceId === priceIds.enterprise) return 4;
  
  return 2; // fallback
}

export function getAllowedPriceIds(): string[] {
  const priceIds = getStripePriceIds();
  return [priceIds.single, priceIds.team, priceIds.enterprise];
}